/** @module Sourcing/NewFromStyleSupplierRequestWizard */
define([
	"dojo/_base/declare",
	"Apparel/NewFromStyleWizard",
	"./StyleSupplierRequestWizardMixIn"
], function(declare,NewFromStyleWizard,StyleSupplierRequestWizardMixIn) {

	return declare([NewFromStyleWizard, StyleSupplierRequestWizardMixIn], {

	});
});